// NOTE: See ApiCommand.cs for an explanation on why we need to fiddle with the namespaces
// #if BOOTSTRAP
// namespace Tableau.JavaScript.Vql.Bootstrap
// #else
// namespace Tableau.JavaScript.Vql.ApiShared
// #endif
enum NonApiCommandName {
  Bootstrap = 'tableau.bootstrap',
  Completed = 'completed',
  VisibleRectRequest = 'layoutInfoReq',
  VisibleRectResponse = 'layoutInfoResp',
  LegacyVizOffsetResp = 'vizOffsetResp',
  EnableVisibleRectCommunication = 'tableau.enableVisibleRectCommunication',
  TableauCompleted = 'tableau.completed',
  UnhandledException = 'tableau.unhandledException',
  Listening = 'tableau.listening',
  Responsive = 'tableau.responsive',
  ScaleFactorRequest = 'sf?',
  ScaleFactorResponse = 'sf'
}

/**
* Represents a legacy command that is sent across the iframe boundary.
* If you're making a new command, please use <see cref="ApiCommand"/> instead. This version is only intended to
* wrap legacy commands from viz_v1.
*/
/*[ScriptNamespace("tab")]*/
class NonApiCommand {
  private parameters: string[];
  // NOTE: this used to be a variadic param: parameters: (typescript ...string[]) (c# params string[] parameters)
  public constructor(name: NonApiCommandName, parameters: string[]) {
    this.Name = name;
    this.parameters = parameters;
  }

  public Name: NonApiCommandName;

  public get Parameters(): string[] {
    return this.parameters;
  }

  public static Parse(serialized: string): NonApiCommand {
    let args: Array<string> = serialized.split(',');
    let name: NonApiCommandName = args[0] as NonApiCommandName;
    let parameters: string[] = args.slice(1);
    return new NonApiCommand(name, parameters);
  }

  public Serialize(): string {
    let message = new Array<string>();
    message.push(this.Name.toString());
    message = message.concat(this.parameters);
    return message.join(',');
  }
}

export { NonApiCommandName, NonApiCommand };
